// src/components/payments/PaymentFailed.js
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import './PaymentResult.css';

const PaymentFailed = () => {
    usePageTitle('Payment Failed');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const errorMessage = searchParams.get('message') || 'Payment could not be processed';
    const errorCode = searchParams.get('code');

    const handleRetryPayment = () => {
        navigate('/subscriptions');
    };

    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };

    const handleContactSupport = () => {
        window.location.href = 'mailto:support@ehaazri.com?subject=Payment Failed - Error Code: ' + (errorCode || 'N/A');
    };

    return (
        <div className="payment-result-container">
            <div className="payment-result-card failed">
                <div className="payment-result-icon">
                    <i className="fas fa-exclamation-circle"></i>
                </div>
                <h1>Payment Failed</h1>
                <p className="payment-result-message">
                    {errorMessage}
                </p>

                {errorCode && (
                    <div className="error-code">
                        <span>Error Code: {errorCode}</span>
                    </div>
                )}

                <div className="payment-result-info">
                    <h4>Common reasons for payment failure:</h4>
                    <ul>
                        <li>
                            <i className="fas fa-credit-card"></i>
                            Insufficient funds in your account
                        </li>
                        <li>
                            <i className="fas fa-ban"></i>
                            Card declined by your bank
                        </li>
                        <li>
                            <i className="fas fa-lock"></i>
                            Incorrect card details or CVV
                        </li>
                        <li>
                            <i className="fas fa-globe"></i>
                            International transactions blocked
                        </li>
                        <li>
                            <i className="fas fa-shield-alt"></i>
                            Security restrictions on your card
                        </li>
                    </ul>
                </div>

                <div className="payment-result-suggestions">
                    <h4>What can I do?</h4>
                    <div className="suggestions-grid">
                        <div className="suggestion-card">
                            <i className="fas fa-phone"></i>
                            <h5>Contact Your Bank</h5>
                            <p>Verify with your bank that the card can be used for online payments</p>
                        </div>
                        <div className="suggestion-card">
                            <i className="fas fa-credit-card"></i>
                            <h5>Try Another Card</h5>
                            <p>Use a different payment method or card</p>
                        </div>
                        <div className="suggestion-card">
                            <i className="fas fa-university"></i>
                            <h5>Bank Transfer</h5>
                            <p>Choose manual bank transfer as an alternative payment method</p>
                        </div>
                    </div>
                </div>

                <div className="payment-result-actions">
                    <button className="btn btn-primary" onClick={handleRetryPayment}>
                        <i className="fas fa-redo"></i>
                        Try Again
                    </button>
                    <button className="btn btn-secondary" onClick={handleContactSupport}>
                        <i className="fas fa-headset"></i>
                        Contact Support
                    </button>
                    <button className="btn btn-secondary" onClick={handleGoToDashboard}>
                        <i className="fas fa-home"></i>
                        Go to Dashboard
                    </button>
                </div>

                <div className="payment-help">
                    <p>
                        <i className="fas fa-info-circle"></i>
                        If you continue to experience issues, please contact our support team at{' '}
                        <a href="mailto:support@ehaazri.com">support@ehaazri.com</a> with error code{' '}
                        {errorCode || 'N/A'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailed;
